import type { CSSProperties } from 'react'
import logoUrl from '../assets/qmeter-logo.png'
import { useStaffText } from './StaffText'

/** The Qmeter wordmark with the small product label. Drawn as a mask, so it takes --ink in both themes. */
export function Logo({ product = true }: { product?: boolean }) {
  const { say } = useStaffText()
  return (
    <span className="logo" style={{ '--logo': `url(${logoUrl})` } as CSSProperties}>
      <span className="logo__mark" aria-hidden="true" />
      {product && <span className="logo__product">{say('ui.product')}</span>}
    </span>
  )
}
